import {GET_COINS} from '../constants/index';

const initialState = {};

const coinDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COINS:
      return {
        ...state,
        coinDetail: action.payload,
      };
    default:
      return state;
  }
};
export default coinDetailReducer;
